'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const RETAIN_METHOD = Symbol('retain');
const RELEASE_METHOD = Symbol('release');
const RETAINED_BY = Symbol('retainedBy');

exports.RELEASE_METHOD = RELEASE_METHOD;
exports.RETAINED_BY = RETAINED_BY;
exports.RETAIN_METHOD = RETAIN_METHOD;
